

















import { Component, Vue } from 'vue-property-decorator'
import QuestionList from '@/components/QuestionList.vue'

@Component({
  components: {
    QuestionList
  }
})
export default class Question extends Vue {}
